<template>
	<div>
		<el-dialog title="提示" :visible.sync="visible" width="400px" class="tipDialog" :close-on-click-modal="false" :before-close="handleClose">
			<div class="flex-row-align-center mt-16">
				<YxAvatar :src="row.head" :size="60" />
				<div class="ml-16">
					<p class="flex-row-align-center yx-color-text-primary">
						<platformIcon :platformId="row.platform_id"></platformIcon>
						<span class="ml-4">{{ row.anchor_name }}</span>
					</p>
					<p class="flex-row-align-center yx-color-text-regular font-h6-regular mt-8">
						<span class="yx-color-danger mr-2">*</span>
						<span style="flex-shrink: 0">视频号ID：</span>
						<el-input v-model="sphId" class="fz-12" placeholder="请及时补充避免影响业绩" />
					</p>
				</div>
			</div>
			<div class="yx-color-primary font-h6-regular mt-16 text-align-right cursor-pointer" @click="handOpenUrl">如何获取视频号id?</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="confirm" :disabled="!sphId">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { sphIdSearchList } from '@/api/talentCRM';
import YxAvatar from '@/components/yxAvatar';
export default {
	components: {
		Tip: () => import('@/components/ui/tip'),
		YxAvatar,
	},
	props: {
		//naturalTalentList 自然达人 clueSeas 线索公海   other其他
		source: {
			type: String,
			default: 'other',
		},
	},
	data() {
		return {
			visible: false,
			row: {},
			sphId: '',
			type: '', // distribution分配 claim认领
		};
	},
	methods: {
		show(row = {}, type = '') {
			this.type = type;
			this.row = row;
			this.visible = true;
			this.checksphId();
		},
		async checksphId() {
			const res = await sphIdSearchList({ anchorName: this.row.anchor_name });
			if (res.video_no) this.sphId = res.video_no;
		},

		async confirm() {
			this.$emit('confirm', this.row, this.sphId);
			this.handleClose();
			if (this.type === 'distribution') this.$message.success('填写成功！');
		},
		handleClose() {
			this.sphId = '';
			this.visible = false;
		},
		handOpenUrl() {
			window.open('https://yangxuan.feishu.cn/docx/ComydzaEOoobhhxl05kcdhPsnJb?from=from_copylink', '_blank');
		},
	},
};
</script>

<style lang="less" scoped></style>
